<template>
  <div>
    <Breadcrumb msg1="客户管理" msg2="360视图" />
    <el-card v-if="data.customer">
      <div style="margin-bottom: 10px">
        <el-button icon="el-icon-back" @click="$router.back()">返回</el-button>
      </div>
      <el-row :gutter="10">
        <el-col :span="6"><div class="stat-card"><div class="stat-title">{{ data.customer.name }}</div><div class="stat-sub">{{ data.customer.phone }}</div></div></el-col>
        <el-col :span="4"><div class="stat-card"><div class="stat-num">{{ data.appointments.length }}</div><div class="stat-sub">预约记录</div></div></el-col>
        <el-col :span="4"><div class="stat-card"><div class="stat-num">{{ data.optometries.length }}</div><div class="stat-sub">验光记录</div></div></el-col>
        <el-col :span="4"><div class="stat-card"><div class="stat-num">{{ data.prescriptions.length }}</div><div class="stat-sub">处方数</div></div></el-col>
        <el-col :span="4"><div class="stat-card"><div class="stat-num">{{ data.glassesOrders.length }}</div><div class="stat-sub">配镜订单</div></div></el-col>
        <el-col :span="2"><div class="stat-card"><div class="stat-num">{{ data.charges.length }}</div><div class="stat-sub">收费单</div></div></el-col>
      </el-row>
      <el-descriptions title="基本信息" :column="3" border style="margin-top: 15px">
        <el-descriptions-item label="档案编号">{{ data.customer.customerNo }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ data.customer.gender === 1 ? '女' : '男' }}</el-descriptions-item>
        <el-descriptions-item label="年龄">{{ data.customer.age }}</el-descriptions-item>
        <el-descriptions-item label="出生日期">{{ data.customer.birthday }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ data.customer.idCard }}</el-descriptions-item>
        <el-descriptions-item label="来源">{{ data.customer.source }}</el-descriptions-item>
        <el-descriptions-item label="地址" :span="3">{{ data.customer.address }}</el-descriptions-item>
        <el-descriptions-item label="标签">{{ data.customer.tags }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ data.customer.remark }}</el-descriptions-item>
      </el-descriptions>
      <el-alert v-if="data.member" :title="'会员信息：等级ID ' + (data.member.levelId || '-') + '｜余额 ¥' + (data.member.balance || 0) + '｜积分 ' + (data.member.points || 0)" type="success" :closable="false" style="margin-top: 15px" show-icon></el-alert>
    </el-card>

    <el-card style="margin-top: 10px">
      <el-tabs v-model="tab">
        <el-tab-pane label="预约" name="appointments">
          <el-table :data="data.appointments" border size="small">
            <el-table-column prop="appointmentDate" label="日期"></el-table-column>
            <el-table-column prop="timeSlot" label="时段"></el-table-column>
            <el-table-column prop="channel" label="渠道"></el-table-column>
            <el-table-column prop="doctorId" label="医生ID"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="reason" label="事由" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="分诊" name="triages">
          <el-table :data="data.triages" border size="small">
            <el-table-column prop="visitDate" label="就诊日期"></el-table-column>
            <el-table-column prop="arriveTime" label="到诊时间"></el-table-column>
            <el-table-column prop="departmentId" label="科室ID"></el-table-column>
            <el-table-column prop="doctorId" label="医生ID"></el-table-column>
            <el-table-column prop="priority" label="优先级"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="symptom" label="主诉" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="验光" name="optometries">
          <el-table :data="data.optometries" border size="small">
            <el-table-column prop="refractionDate" label="日期"></el-table-column>
            <el-table-column prop="refractionType" label="类型"></el-table-column>
            <el-table-column prop="pd" label="PD"></el-table-column>
            <el-table-column prop="conclusion" label="结论" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="openDetail('optometry', scope.row.id)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="视功能" name="visionFunctions">
          <el-table :data="data.visionFunctions" border size="small">
            <el-table-column prop="checkDate" label="日期"></el-table-column>
            <el-table-column prop="checkType" label="类型"></el-table-column>
            <el-table-column prop="vfConclusion" label="检查结论" show-overflow-tooltip></el-table-column>
            <el-table-column prop="aca" label="AC/A"></el-table-column>
            <el-table-column prop="npc" label="集合近点"></el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="openDetail('visionFunction', scope.row.id)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="处方" name="prescriptions">
          <el-table :data="data.prescriptions" border size="small">
            <el-table-column prop="prescriptionNo" label="处方号"></el-table-column>
            <el-table-column prop="prescriptionType" label="类型"></el-table-column>
            <el-table-column prop="diagnosis" label="诊断"></el-table-column>
            <el-table-column prop="issueDate" label="开具日期"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="openDetail('prescription', scope.row.id)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="配镜订单" name="glassesOrders">
          <el-table :data="data.glassesOrders" border size="small">
            <el-table-column prop="orderNo" label="订单号"></el-table-column>
            <el-table-column prop="orderDate" label="日期"></el-table-column>
            <el-table-column prop="totalAmount" label="金额"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column label="操作" width="90">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="openDetail('glassesOrder', scope.row.id)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="收费" name="charges">
          <el-table :data="data.charges" border size="small">
            <el-table-column prop="chargeNo" label="单号"></el-table-column>
            <el-table-column prop="chargeTime" label="时间"></el-table-column>
            <el-table-column prop="totalAmount" label="金额"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="验配随访" name="lensFittings">
          <el-table :data="data.lensFittings" border size="small">
            <el-table-column prop="lensType" label="类型"></el-table-column>
            <el-table-column prop="brand" label="品牌"></el-table-column>
            <el-table-column prop="model" label="型号"></el-table-column>
            <el-table-column prop="fittingDate" label="验配日期"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- ============ 详情弹窗 ============ -->
    <el-dialog :title="detail.title" :visible.sync="detail.show" width="900px" :close-on-click-modal="false">
      <!-- 验光详情 -->
      <template v-if="detail.type === 'optometry'">
        <el-descriptions title="基本信息" :column="2" border size="small">
          <el-descriptions-item label="客户ID">{{ v(detail.row.customerId) }}</el-descriptions-item>
          <el-descriptions-item label="检查日期">{{ v(detail.row.refractionDate) }}</el-descriptions-item>
          <el-descriptions-item label="检查类型">{{ v(detail.row.refractionType) }}</el-descriptions-item>
          <el-descriptions-item label="来源单号">{{ v(detail.row.sourceNo) }}</el-descriptions-item>
          <el-descriptions-item label="来源类型">{{ v(detail.row.sourceType) }}</el-descriptions-item>
          <el-descriptions-item label="验光师ID">{{ v(detail.row.optometristId) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="电脑验光" :column="2" border size="small" style="margin-top: 12px">
          <el-descriptions-item label="OD球镜">{{ v(detail.row.autoOdSphere) }}</el-descriptions-item>
          <el-descriptions-item label="OD柱镜">{{ v(detail.row.autoOdCylinder) }}</el-descriptions-item>
          <el-descriptions-item label="OD轴位">{{ v(detail.row.autoOdAxis) }}</el-descriptions-item>
          <el-descriptions-item label="OS球镜">{{ v(detail.row.autoOsSphere) }}</el-descriptions-item>
          <el-descriptions-item label="OS柱镜">{{ v(detail.row.autoOsCylinder) }}</el-descriptions-item>
          <el-descriptions-item label="OS轴位">{{ v(detail.row.autoOsAxis) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="主觉验光" :column="2" border size="small" style="margin-top: 12px">
          <el-descriptions-item label="OD球镜">{{ v(detail.row.subOdSphere) }}</el-descriptions-item>
          <el-descriptions-item label="OD柱镜">{{ v(detail.row.subOdCylinder) }}</el-descriptions-item>
          <el-descriptions-item label="OD轴位">{{ v(detail.row.subOdAxis) }}</el-descriptions-item>
          <el-descriptions-item label="OS球镜">{{ v(detail.row.subOsSphere) }}</el-descriptions-item>
          <el-descriptions-item label="OS柱镜">{{ v(detail.row.subOsCylinder) }}</el-descriptions-item>
          <el-descriptions-item label="OS轴位">{{ v(detail.row.subOsAxis) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="终配数据" :column="2" border size="small" style="margin-top: 12px">
          <el-descriptions-item label="PD">{{ v(detail.row.pd) }}</el-descriptions-item>
          <el-descriptions-item label="近用PD">{{ v(detail.row.pdNear) }}</el-descriptions-item>
          <el-descriptions-item label="下加光">{{ v(detail.row.addPower) }}</el-descriptions-item>
          <el-descriptions-item label="OD裸眼视力">{{ v(detail.row.visualAcuityOd) }}</el-descriptions-item>
          <el-descriptions-item label="OS裸眼视力">{{ v(detail.row.visualAcuityOs) }}</el-descriptions-item>
          <el-descriptions-item label="试戴架">{{ v(detail.row.trialFrame) }}</el-descriptions-item>
          <el-descriptions-item label="试戴结果" :span="2">{{ v(detail.row.trialResult) }}</el-descriptions-item>
          <el-descriptions-item label="结论">{{ v(detail.row.conclusion) }}</el-descriptions-item>
          <el-descriptions-item label="下次复查">{{ v(detail.row.nextReviewDate) }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ v(detail.row.remark) }}</el-descriptions-item>
        </el-descriptions>
      </template>

      <!-- 配镜订单详情 -->
      <template v-if="detail.type === 'glassesOrder'">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="订单号">{{ v(detail.row.orderNo) }}</el-descriptions-item>
          <el-descriptions-item label="客户ID">{{ v(detail.row.customerId) }}</el-descriptions-item>
          <el-descriptions-item label="处方ID">{{ v(detail.row.prescriptionId) }}</el-descriptions-item>
          <el-descriptions-item label="镜框ID">{{ v(detail.row.frameId) }}</el-descriptions-item>
          <el-descriptions-item label="镜框名称" :span="2">{{ v(detail.row.frameName) }}</el-descriptions-item>
          <el-descriptions-item label="镜片类型">{{ v(detail.row.lensType) }}</el-descriptions-item>
          <el-descriptions-item label="镜片规格" :span="2">{{ v(detail.row.lensSpec) }}</el-descriptions-item>
          <el-descriptions-item label="OD度数">{{ v(detail.row.odDegree) }}</el-descriptions-item>
          <el-descriptions-item label="OS度数">{{ v(detail.row.osDegree) }}</el-descriptions-item>
          <el-descriptions-item label="PD">{{ v(detail.row.pd) }}</el-descriptions-item>
          <el-descriptions-item label="总金额">{{ v(detail.row.totalAmount) }}</el-descriptions-item>
          <el-descriptions-item label="折扣金额">{{ v(detail.row.discountAmount) }}</el-descriptions-item>
          <el-descriptions-item label="实收金额">{{ v(detail.row.paidAmount) }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ v(detail.row.status) }}</el-descriptions-item>
          <el-descriptions-item label="渠道">{{ v(detail.row.channel) }}</el-descriptions-item>
          <el-descriptions-item label="销售员ID">{{ v(detail.row.salespersonId) }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ v(detail.row.orderDate) }}</el-descriptions-item>
          <el-descriptions-item label="取镜日期">{{ v(detail.row.takeDate) }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ v(detail.row.remark) }}</el-descriptions-item>
        </el-descriptions>
      </template>

      <!-- 视功能详情 -->
      <template v-if="detail.type === 'visionFunction'">
        <el-descriptions title="基本信息" :column="2" border size="small">
          <el-descriptions-item label="客户ID">{{ v(detail.row.customerId) }}</el-descriptions-item>
          <el-descriptions-item label="检查日期">{{ v(detail.row.checkDate) }}</el-descriptions-item>
          <el-descriptions-item label="检查类型">{{ v(detail.row.checkType) }}</el-descriptions-item>
          <el-descriptions-item label="结果">{{ v(detail.row.result) }}</el-descriptions-item>
          <el-descriptions-item label="医生ID">{{ v(detail.row.doctorId) }}</el-descriptions-item>
          <el-descriptions-item label="来源单号">{{ v(detail.row.sourceNo) }}</el-descriptions-item>
          <el-descriptions-item label="检查项目" :span="2">{{ v(detail.row.item) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="眼位与隐斜" :column="2" border size="small" style="margin-top: 12px">
          <el-descriptions-item label="主导眼">{{ v(detail.row.dominantEye) }}</el-descriptions-item>
          <el-descriptions-item label="远隐斜">{{ v(detail.row.phoriaFar) }}</el-descriptions-item>
          <el-descriptions-item label="近隐斜">{{ v(detail.row.phoriaNear) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="调节功能" :column="2" border size="small" style="margin-top: 12px">
          <el-descriptions-item label="远调节储备1">{{ v(detail.row.accReserveFar1) }}</el-descriptions-item>
          <el-descriptions-item label="远调节储备2">{{ v(detail.row.accReserveFar2) }}</el-descriptions-item>
          <el-descriptions-item label="近调节储备1">{{ v(detail.row.accReserveNear1) }}</el-descriptions-item>
          <el-descriptions-item label="近调节储备2">{{ v(detail.row.accReserveNear2) }}</el-descriptions-item>
          <el-descriptions-item label="调节灵活度1">{{ v(detail.row.accFlexibility1) }}</el-descriptions-item>
          <el-descriptions-item label="调节灵活度2">{{ v(detail.row.accFlexibility2) }}</el-descriptions-item>
          <el-descriptions-item label="放松值">{{ v(detail.row.relaxation) }}</el-descriptions-item>
          <el-descriptions-item label="OD放松">{{ v(detail.row.relaxationOd) }}</el-descriptions-item>
          <el-descriptions-item label="OS放松">{{ v(detail.row.relaxationOs) }}</el-descriptions-item>
          <el-descriptions-item label="PRA">{{ v(detail.row.pra) }}</el-descriptions-item>
          <el-descriptions-item label="NRA">{{ v(detail.row.nra) }}</el-descriptions-item>
          <el-descriptions-item label="OD调节幅度">{{ v(detail.row.amplitudeOd) }}</el-descriptions-item>
          <el-descriptions-item label="OS调节幅度">{{ v(detail.row.amplitudeOs) }}</el-descriptions-item>
          <el-descriptions-item label="双眼调节幅度">{{ v(detail.row.amplitudeBin) }}</el-descriptions-item>
          <el-descriptions-item label="OD调节力">{{ v(detail.row.powerOd) }}</el-descriptions-item>
          <el-descriptions-item label="OS调节力">{{ v(detail.row.powerOs) }}</el-descriptions-item>
          <el-descriptions-item label="双眼调节力">{{ v(detail.row.powerBin) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="融像功能" :column="2" border size="small" style="margin-top: 12px">
          <el-descriptions-item label="远融像储备1">{{ v(detail.row.fusionReserveFar1) }}</el-descriptions-item>
          <el-descriptions-item label="远融像储备2">{{ v(detail.row.fusionReserveFar2) }}</el-descriptions-item>
          <el-descriptions-item label="远融像储备3">{{ v(detail.row.fusionReserveFar3) }}</el-descriptions-item>
          <el-descriptions-item label="远融像储备4">{{ v(detail.row.fusionReserveFar4) }}</el-descriptions-item>
          <el-descriptions-item label="近融像储备1">{{ v(detail.row.fusionReserveNear1) }}</el-descriptions-item>
          <el-descriptions-item label="近融像储备2">{{ v(detail.row.fusionReserveNear2) }}</el-descriptions-item>
          <el-descriptions-item label="近融像储备3">{{ v(detail.row.fusionReserveNear3) }}</el-descriptions-item>
          <el-descriptions-item label="近融像储备4">{{ v(detail.row.fusionReserveNear4) }}</el-descriptions-item>
          <el-descriptions-item label="远垂直集合1">{{ v(detail.row.verticalAccFar1) }}</el-descriptions-item>
          <el-descriptions-item label="远垂直集合2">{{ v(detail.row.verticalAccFar2) }}</el-descriptions-item>
          <el-descriptions-item label="近垂直集合1">{{ v(detail.row.verticalAccNear1) }}</el-descriptions-item>
          <el-descriptions-item label="近垂直集合2">{{ v(detail.row.verticalAccNear2) }}</el-descriptions-item>
          <el-descriptions-item label="远垂直融像1">{{ v(detail.row.verticalFusionFar1) }}</el-descriptions-item>
          <el-descriptions-item label="远垂直融像2">{{ v(detail.row.verticalFusionFar2) }}</el-descriptions-item>
          <el-descriptions-item label="近垂直融像1">{{ v(detail.row.verticalFusionNear1) }}</el-descriptions-item>
          <el-descriptions-item label="近垂直融像2">{{ v(detail.row.verticalFusionNear2) }}</el-descriptions-item>
          <el-descriptions-item label="BI远模糊点">{{ v(detail.row.biFarBlur) }}</el-descriptions-item>
          <el-descriptions-item label="BI远破裂点">{{ v(detail.row.biFarBreak) }}</el-descriptions-item>
          <el-descriptions-item label="BI远恢复点">{{ v(detail.row.biFarRecover) }}</el-descriptions-item>
          <el-descriptions-item label="BI近模糊点">{{ v(detail.row.biNearBlur) }}</el-descriptions-item>
          <el-descriptions-item label="BI近破裂点">{{ v(detail.row.biNearBreak) }}</el-descriptions-item>
          <el-descriptions-item label="BI近恢复点">{{ v(detail.row.biNearRecover) }}</el-descriptions-item>
          <el-descriptions-item label="BO远模糊点">{{ v(detail.row.boFarBlur) }}</el-descriptions-item>
          <el-descriptions-item label="BO远破裂点">{{ v(detail.row.boFarBreak) }}</el-descriptions-item>
          <el-descriptions-item label="BO远恢复点">{{ v(detail.row.boFarRecover) }}</el-descriptions-item>
          <el-descriptions-item label="BO近模糊点">{{ v(detail.row.boNearBlur) }}</el-descriptions-item>
          <el-descriptions-item label="BO近破裂点">{{ v(detail.row.boNearBreak) }}</el-descriptions-item>
          <el-descriptions-item label="BO近恢复点">{{ v(detail.row.boNearRecover) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="立体视与集合" :column="2" border size="small" style="margin-top: 12px">
          <el-descriptions-item label="CISS">{{ v(detail.row.ciss) }}</el-descriptions-item>
          <el-descriptions-item label="立体视">{{ v(detail.row.stereoVision) }}</el-descriptions-item>
          <el-descriptions-item label="AC/A">{{ v(detail.row.aca) }}</el-descriptions-item>
          <el-descriptions-item label="AC/A测量法">{{ v(detail.row.acaMethod) }}</el-descriptions-item>
          <el-descriptions-item label="集合近点">{{ v(detail.row.npc) }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="结论分析" :column="2" border size="small" style="margin-top: 12px">
          <el-descriptions-item label="检查结论">{{ v(detail.row.vfConclusion) }}</el-descriptions-item>
          <el-descriptions-item label="异常原因">{{ v(detail.row.vfReason) }}</el-descriptions-item>
          <el-descriptions-item label="主觉结论">{{ v(detail.row.subjectiveConclusion) }}</el-descriptions-item>
          <el-descriptions-item label="综合结论">{{ v(detail.row.conclusion) }}</el-descriptions-item>
          <el-descriptions-item label="结果分析" :span="2">{{ v(detail.row.resultAnalysis) }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ v(detail.row.remark) }}</el-descriptions-item>
        </el-descriptions>
      </template>

      <!-- 处方详情 -->
      <template v-if="detail.type === 'prescription'">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="处方号">{{ v(detail.row.prescriptionNo) }}</el-descriptions-item>
          <el-descriptions-item label="客户ID">{{ v(detail.row.customerId) }}</el-descriptions-item>
          <el-descriptions-item label="医生ID">{{ v(detail.row.doctorId) }}</el-descriptions-item>
          <el-descriptions-item label="处方类型">{{ v(detail.row.prescriptionType) }}</el-descriptions-item>
          <el-descriptions-item label="诊断" :span="2">{{ v(detail.row.diagnosis) }}</el-descriptions-item>
          <el-descriptions-item label="开具日期">{{ v(detail.row.issueDate) }}</el-descriptions-item>
          <el-descriptions-item label="有效期(天)">{{ v(detail.row.validDays) }}</el-descriptions-item>
          <el-descriptions-item label="签名">{{ v(detail.row.signature) }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ v(detail.row.status) }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ v(detail.row.remark) }}</el-descriptions-item>
        </el-descriptions>
      </template>

      <span slot="footer">
        <el-button @click="detail.show = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      id: this.$route.params.id,
      tab: 'appointments',
      data: { customer: null, appointments: [], triages: [], optometries: [], visionFunctions: [], prescriptions: [], glassesOrders: [], charges: [], lensFittings: [], member: null },
      detail: { show: false, type: '', title: '', row: {} }
    }
  },
  created () {
    this.$axios.http.get(`/customers/${this.id}/overview`).then(res => {
      if (res.data.status === 200) {
        this.data = Object.assign(this.data, res.data.data)
      } else {
        this.$message.error(res.data.message)
      }
    })
  },
  methods: {
    v (x) {
      return (x === null || x === undefined || x === '') ? '-' : x
    },
    openDetail (type, rowId) {
      const urlMap = {
        optometry: `/optometries/${rowId}`,
        glassesOrder: `/glassesOrders/${rowId}`,
        visionFunction: `/visionFunctions/${rowId}`,
        prescription: `/prescriptions/${rowId}`
      }
      const titleMap = {
        optometry: '验光详情',
        glassesOrder: '配镜订单详情',
        visionFunction: '视功能检查详情',
        prescription: '处方详情'
      }
      this.$axios.http.get(urlMap[type]).then(res => {
        if (res.data.status === 200) {
          this.detail.row = res.data.data || {}
          this.detail.type = type
          this.detail.title = titleMap[type]
          this.detail.show = true
        } else {
          this.$message.error(res.data.message || '详情加载失败')
        }
      }).catch(() => {
        this.$message.error('详情加载失败')
      })
    }
  }
}
</script>

<style scoped>
.stat-card {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 12px;
  text-align: center;
}
.stat-num { font-size: 22px; color: #409EFF; font-weight: bold; }
.stat-title { font-size: 18px; color: #333; font-weight: bold; }
.stat-sub { color: #909399; font-size: 13px; margin-top: 4px; }
</style>
